import React from 'react';
import withSizes from 'react-sizes';

import { BannerDescription } from './BannerDescription/BannerDescription.jsx';
import {
  RollUpClickableTitle,
  WrapBannerImageWithHref,
} from '../../../../shared/index.jsx';

const mapSizesToProps = ({ width }) => ({
  winW: width
})

class GitaFestival26 extends React.Component {
  bannerImgSrc() {
    return this.props.winW >= 1024
      ? '/img/2026/10/GitaFestival26/dt.jpg'
      : '/img/2026/10/GitaFestival26/mob.jpg'
  }

  promoLink = 'https://kcw.com.ua/schedule '

  render() {
    return (
      <div className='mp__sertificat'>
        <div className='wd'>
          <div className='sertificat'>
            <WrapBannerImageWithHref href={this.promoLink} src={this.bannerImgSrc()} />
            <RollUpClickableTitle title='Міжнародні фестивальні гіти та нове українське кіно з 15 до 21 жовтня у кінотеатрі «Жовтень»' />
            <BannerDescription promoLink={this.promoLink} />
          </div>
        </div>
      </div>
    )
  }
}

export default withSizes(mapSizesToProps)(GitaFestival26)


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/GitaFestival26/impl/GitaFestival26.jsx